import { ValueOf } from 'utils/types/common'

export enum SortDirection {
  ASC = 'asc',
  DESC = 'desc',
}

export type SortDirectionType = ValueOf<typeof SortDirection>
